import { Controller, useFormContext } from 'react-hook-form';
import useTranslation from 'next-translate/useTranslation';

//libs
import { time_format } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

export function PlatformTimeFormat() {
    const { t } = useTranslation('settings');

    const options = time_format(t);

    const {
        control,
        watch,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <div className="w-full">
            <Controller
                key={'time_format'}
                control={control}
                name={'time_format'}
                render={({ field: { onChange, value } }) => {
                    return (
                        <SelectComponent
                            selected={options?.find((item) => value['value'] === item.value)}
                            setSelected={onChange}
                            label={t('platform_page.time_format')}
                            error={errors.time_format?.message}
                            options={options}
                        />
                    );
                }}
            />
            <p className="mb-3.5 mt-1 font-GMedium text-xs italic text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('platform_page.time_format_tip_' + (watch('time_format')['value'] ?? ''))}
            </p>
        </div>
    );
}
